import {
	ADD_BUNDLE_TO_VIRTUAL_LOG,
	ADD_TO_VIRTUAL_LOG,
	MOVE_BUNDLE_TO_INDEX_IN_VIRTUAL_LOG,
	REMOVE_BUNDLE_FROM_VIRTUAL_LOG,
	REMOVE_FROM_VIRTUAL_LOG,
	REMOVED_VIRTUAL_LOG_FROM_WATCHLIST,
	RESET_BUNDLE_NUMBERS,
	SET_BUNDLES_FOR_VIRTUAL_LOG,
	SET_VIRTUAL_LOG,
	SET_VIRTUAL_LOG_PROPS,
	SET_VIRTUAL_LOG_TEASER,
	START_VIRTUAL_LOG_CREATION,
	UPDATE_CALCULATED_VIRTUAL_LOG_VALUES,
	UPDATE_VIRTUAL_LOG_ON_WATCHLIST,
	MUTATE_SNACK, REPLACE_WATCHLIST, SET_VIRTUAL_LOG_WATCHLIST_ITEM, SET_VIRTUAL_LOG_EDIT_MODE, SET_VIRTUAL_LOG_UID
} from "@/store/mutations.type";
import {INITIAL_VIRTUAL_LOG} from "@/common/constants";
import {
	FETCH_BUNDLES_FOR_LOG,
	LOAD_LOG_FOR_VIRTUAL_LOG,
	UPDATE_VIRTUAL_LOG,
	SET_SNACK
} from "@/store/actions.type";
import {SearchService, VirtualLogService} from "@/common/api";

const state = {
	log: null,
	watchlistItem: null,
	editMode: false
};

const getters = {
	virtualLog: state => state.log,
	virtualLogWatchlistItem: state => state.watchlistItem,
	editMode: state => state.editMode
};

const actions = {
	async [LOAD_LOG_FOR_VIRTUAL_LOG]({commit}, identifier) {
		return SearchService.find(identifier)
			.then(({data}) => {
				commit(ADD_TO_VIRTUAL_LOG, {log: data, snack: false});
			})
			.catch(error => {
				throw new Error(error);
			})
	},
	async [UPDATE_VIRTUAL_LOG]({commit}, params) {
		return VirtualLogService.update(params)
			.then(({data}) => {
				const virtualLog = data.objects.log,
					watchlist = data.objects.watchlist;

				if (params.hasOwnProperty('logs')) {
					virtualLog.logs = params.logs;
				}
				commit(SET_VIRTUAL_LOG_UID, virtualLog.uid);
				commit(UPDATE_VIRTUAL_LOG_ON_WATCHLIST, virtualLog);
				commit(REPLACE_WATCHLIST, watchlist);
				//commit(MUTATE_SNACK, data.status);
			})
			.catch(error => {
				throw new Error(error);
			});
	}
};

const mutations = {
	[SET_VIRTUAL_LOG](state, log) {
		state.log = log;
	},
	[SET_VIRTUAL_LOG_UID](state, uid) {
		state.log.uid = uid;
	},
	[START_VIRTUAL_LOG_CREATION](state, user) {
		state.log = {
			...INITIAL_VIRTUAL_LOG,
			name: '',
			owner: user.warehouseCompany.uid,
			createdBy: user.uid,
			logs: []
		};
	},
	[SET_BUNDLES_FOR_VIRTUAL_LOG](state, bundles) {
		state.log.bundles = bundles;
	},
	async [ADD_TO_VIRTUAL_LOG](state, {log, snack}) {
		const logId = (log.logId || log.intLogId);

		if (!state.log.hasOwnProperty('logs')) {
			state.log.logs = [];
		}

		// add log if it is not already part of this virtual log
		if (state.log.logs.find(value => (value.logId || value.intLogId) === logId) === undefined) {
			const index = state.log.logsMeta.findIndex(logMeta => logMeta.logId === logId);
			if (index === -1) {
				if (!log.bundles || !log.bundles.length) {
					log.bundles = await this.dispatch(FETCH_BUNDLES_FOR_LOG, log);
				}

				state.log.logsMeta.push({
					logId: logId,
					logNo: log.logNo || log.strLogNo,
					bundleCount: log.bundles.length,
					consumedBundles: 0
				});

				// add new log at end of current log
				state.log.logs.push(log);
			} else {
				// insert log at correct place in ordering
				state.log.logs.splice(index, 0, log);
			}
			if (snack) {
				this.dispatch(SET_SNACK, 'addedToVirtualLog');
			}
		} else {
			if (snack) {
				this.dispatch(SET_SNACK, 'alreadyOnVirtualLog');
			}
		}

		if (state.log.species === null) {
			if (log.species) {
				state.log.species = log.species;
			} else {
				state.log.species = {
					name: log.strSpecieName,
					speciesId: log.strSpecieGId
				};
			}
		}
	},
	/**
	 * Removes log and all its bundles from virtual log
	 * @param state
	 * @param log
	 */
	[REMOVE_FROM_VIRTUAL_LOG](state, log) {
		const logId = (log.logId || log.intLogId);

		state.log.logs = state.log.logs.filter(value => (value.logId || value.intLogId) !== logId);
		state.log.bundles = state.log.bundles.filter(value => value.intLogId !== logId);
		state.log.logsMeta = state.log.logsMeta.filter(value => value.logId !== logId);
	},
	/**
	 * Adds bundle to current virtual log
	 * @param state
	 * @param bundle
	 * @param {int} index where to add bundle in bundleList
	 */
	[ADD_BUNDLE_TO_VIRTUAL_LOG](state, {bundle, index}) {
		if (state.log.bundles.find(value => value.intBundleId === bundle.intBundleId) === undefined) {
			if (index === undefined) {
				bundle.originalBundleNo = bundle.strBundleNo;
				// add on last position if no index was specified
				bundle.strBundleNo = `${state.log.bundles.length + 1}`.padStart(3, '0');
				state.log.bundles.push(bundle);
			} else {
				state.log.bundles.splice(index, 0, bundle);
				this.commit(RESET_BUNDLE_NUMBERS);
			}
			state.log.logsMeta.find(logMeta => logMeta.logId === bundle.intLogId).consumedBundles++;
			this.commit(UPDATE_CALCULATED_VIRTUAL_LOG_VALUES);
		}
	},
	[REMOVE_BUNDLE_FROM_VIRTUAL_LOG](state, bundle) {
		state.log.bundles = state.log.bundles.filter(value => value.intBundleId !== bundle.intBundleId);
		state.log.logsMeta.find(logMeta => logMeta.logId === bundle.intLogId).consumedBundles--;

		this.commit(UPDATE_CALCULATED_VIRTUAL_LOG_VALUES);
		this.commit(RESET_BUNDLE_NUMBERS);
	},
	[MOVE_BUNDLE_TO_INDEX_IN_VIRTUAL_LOG](state, {bundle, index}) {
		this.commit(REMOVE_BUNDLE_FROM_VIRTUAL_LOG, bundle);
		this.commit(ADD_BUNDLE_TO_VIRTUAL_LOG, {bundle, index});
	},
	[RESET_BUNDLE_NUMBERS](state) {
		state.log.bundles = state.log.bundles.map((bundle, index) => {
			return {
				...bundle,
				strBundleNo: `${index + 1}`.padStart(3, '0')
			};
		});
	},
	[SET_VIRTUAL_LOG_TEASER](state, teaser) {
		state.log.teaser = teaser;
	},
	[UPDATE_CALCULATED_VIRTUAL_LOG_VALUES](state) {
		state.log.maxLength = state.log.bundles.reduce((acc, bundle) => Math.max(acc, bundle.intLength), 0);
		state.log.logArea = state.log.bundles.reduce((acc, bundle) => acc + bundle.decArea, 0);
	},
	[SET_VIRTUAL_LOG_PROPS](state, updatedProps) {
		state.log = {...state.log, ...updatedProps};
	},
	[REMOVED_VIRTUAL_LOG_FROM_WATCHLIST](state, log) {
		if (state.log && state.log.uid === log.virtual.uid) {
			this.commit(SET_VIRTUAL_LOG, null);
		}
	},
	[SET_VIRTUAL_LOG_WATCHLIST_ITEM](state, watchlistItem) {
		state.watchlistItem = watchlistItem;
	},
	[SET_VIRTUAL_LOG_EDIT_MODE](state, editMode) {
		state.editMode = editMode;
	}
};

export default {
	state,
	getters,
	actions,
	mutations
};